module.exports = __webpack_public_path__ + "static/img/Serve27@2x.21f9541.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Serve27@2x.png
// module id = GKSO
// module chunks = 1